import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectCurrentToken } from '../../app/store/authSlice';
import AppLayout from '../layout/AppLayout';

const RequireAuth = (): JSX.Element => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();

  return token ? <AppLayout /> : <Navigate to={'/login'} state={{ from: location }} replace />;
};

export default RequireAuth;
